import BranchService from "src/services/BranchService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	client_id:"",
	name:"",
	postal:"",
	address:"",
	city:"",
	contact_man:"",
	tel:"",
	email:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.branch,
@property  {array}  modules.branches
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator({
	name: "branch",
	plural: "branches"
}, BranchService, module, types, params);
